export type Point = { x: number; y: number };
export type Tool = 'pen' | 'arrow' | 'rectangle' | 'text';
export type Annotation = { tool: Tool; color: string; points: Point[]; text?: string };
export function drawAnnotations(ctx: CanvasRenderingContext2D, annotations: Annotation[], width: number, height: number) {
  ctx.save();
  ctx.lineCap = 'round'; ctx.lineJoin = 'round';
  const unit = Math.max(1, width / 1280);
  ctx.lineWidth = 3 * unit;
  ctx.font = `bold ${20 * unit}px sans-serif`;
  ctx.textBaseline = 'top';
  for (const mark of annotations) {
    const points = mark.points.map(p => ({ x: p.x * width, y: p.y * height }));
    const a = points[0], b = points.at(-1);
    if (!a || !b) continue;
    ctx.strokeStyle = mark.color; ctx.fillStyle = mark.color;
    if (mark.tool === 'text') {
      for (const [i, line] of (mark.text ?? '').split('\n').entries()) {
        ctx.save(); ctx.strokeStyle = '#fff'; ctx.lineWidth = 4 * unit;
        ctx.strokeText(line, a.x, a.y + i * 24 * unit); ctx.fillText(line, a.x, a.y + i * 24 * unit); ctx.restore();
      }
    } else if (mark.tool === 'rectangle') ctx.strokeRect(a.x, a.y, b.x - a.x, b.y - a.y);
    else {
      ctx.beginPath(); ctx.moveTo(a.x, a.y);
      for (const p of points.slice(1)) ctx.lineTo(p.x, p.y);
      if (points.length === 1) ctx.lineTo(a.x + 0.1, a.y);
      ctx.stroke();
      if (mark.tool === 'arrow') {
        const angle = Math.atan2(b.y - a.y, b.x - a.x), size = 14 * unit;
        ctx.beginPath(); ctx.moveTo(b.x, b.y);
        ctx.lineTo(b.x - size * Math.cos(angle - Math.PI / 6), b.y - size * Math.sin(angle - Math.PI / 6));
        ctx.moveTo(b.x, b.y); ctx.lineTo(b.x - size * Math.cos(angle + Math.PI / 6), b.y - size * Math.sin(angle + Math.PI / 6)); ctx.stroke();
      }
    }
  }
  ctx.restore();
}
export function relativePoint(x: number, y: number, bounds: Pick<DOMRect, 'left' | 'top' | 'width' | 'height'>): Point {
  return { x: Math.max(0, Math.min(1, (x - bounds.left) / bounds.width)), y: Math.max(0, Math.min(1, (y - bounds.top) / bounds.height)) };
}
